import type {
  RecommendCategoryItemRequest,
  RecommendDataSource,
} from '~/api/data-source/recommend';
import { recommendDataSource } from '~/api/data-source/recommend';
import type { MarketProductItem } from '~/api/model';
import { marketProductItemSchema, parseModelArray } from '~/api/model';

export interface RecommendRepository {
  getHomeCategoryItems(): Promise<MarketProductItem[]>;
  getCategoryItems(
    request: RecommendCategoryItemRequest,
  ): Promise<MarketProductItem[]>;
  getClassificationItems(): Promise<MarketProductItem[]>;
}

export class RecommendRepositoryImpl implements RecommendRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: RecommendDataSource = recommendDataSource,
  ) {}

  async getHomeCategoryItems() {
    const response = await this.dataSource.getHomeCategoryItems();
    return parseModelArray(
      marketProductItemSchema,
      response,
      'RecommendProduct',
    );
  }

  async getCategoryItems(request: RecommendCategoryItemRequest) {
    const response = await this.dataSource.getCategoryItems(request);
    return parseModelArray(
      marketProductItemSchema,
      response,
      'RecommendProduct',
    );
  }

  async getClassificationItems() {
    const response = await this.dataSource.getClassificationItems();
    return parseModelArray(
      marketProductItemSchema,
      response,
      'RecommendProduct',
    );
  }
}

export const recommendRepository = new RecommendRepositoryImpl();
